export const baseURL = `https://yoga-store-api.suyashpradhan.repl.co`;

export const products = `${baseURL}/products`;
export const wishlist = `${baseURL}/wishlist`;
export const bagURL = `${baseURL}/bag`;
export const login = `${baseURL}/login`;
export const register = `${baseURL}/register`;
